// app/javascript/controllers/tag_select_controller.js
import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    options: Array
  }

  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ["checkbox_options"], // 이것만 사용하거나
      maxItems: null,
      valueField: "value",
      labelField: "text",
      searchField: ["text"],
      sortField: "text",
      persist: false,
      createOnBlur: false,
      create: false,
      openOnFocus: true,
    })
    this.select.on("item_select", () => this.select.open())
  }

  disconnect() {
    this.select.destroy()
  }
}
